import { render, staticRenderFns } from "./OrdersMadeUpOffshore.vue?vue&type=template&id=d536e41c"
import script from "./OrdersMadeUpOffshore.vue?vue&type=script&lang=js"
export * from "./OrdersMadeUpOffshore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports